export const Arr_VISAInfo = [
  //-------------------------------------------------------------------------
  //VISAInfo
  {
    Page: "VISAInfo",
    TextField: "SelectFieldForObjectState",
    label: "Require VISA support letter?",
    name: "Do_you_require_a_VISA_support_letter",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "VISAInfo",
    TextField: "SelectFieldForObjectState",
    label:
      "Has the student ever been refused a visa for any country including the United Kingdom?",
    name: "Has_the_student_ever_been_refused_a_VISA_for_any_county_including_the_UK",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Do_you_require_a_VISA_support_letter",
  },
  {
    Page: "VISAInfo",
    TextField: "TextFieldForObjectState",
    label:
      "Which country, or countries, has the visa been rejected from previously?",
    name: "Which_country_or_countries_has_the_VISA_been_rejected_from_previously",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "Has_the_student_ever_been_refused_a_VISA_for_any_county_including_the_UK",
  },
  {
    Page: "VISAInfo",
    TextField: "TextFieldForObjectState",
    label: "When was the last time the student’s visa was rejected?",
    name: "When_was_the_last_time_the_students_VISA_was_rejected",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "Has_the_student_ever_been_refused_a_VISA_for_any_county_including_the_UK",
  },
  {
    Page: "VISAInfo",
    TextField: "TextFieldForObjectState",
    label: "Passport Number?",
    name: "Passport_Number",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Do_you_require_a_VISA_support_letter",
    AboveText: (
      <p>
        InvestIN will use this and all other supporting information from this
        form to write your visa letter, therefore please ensure all details are
        accurate.
      </p>
    ),
  },
  {
    Page: "VISAInfo",
    TextField: "TextFieldForObjectState",
    label: "Full Name as written on your passport?",
    name: "Passport_Name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Do_you_require_a_VISA_support_letter",
  },
  {
    Page: "VISAInfo",
    TextField: "TextFieldForObjectState",
    label: "Date of Birth as written on your passport?",
    name: "Passport_DOB",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Do_you_require_a_VISA_support_letter",
  },
  {
    Page: "VISAInfo",
    TextField: "TextFieldForObjectState",
    label: "Nationality as written on your passport?",
    name: "Passport_Nationality",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Do_you_require_a_VISA_support_letter",
  },
];
